import ellipse441Png from '@listening/assets/astro/images/Ellipse-44-1.png';
import formatClearSvg from '@listening/assets/astro/images/format-clear.svg';
import speakLineSvg from '@listening/assets/astro/images/speak-line.svg';
import voiceprintLineSvg from '@listening/assets/astro/images/voiceprint-line.svg';

export function BrandLogosSection() {
  return (
    <section className='flex flex-col items-center gap-8 px-5 pt-8 pb-[95px] sm:px-14 sm:pt-14 lg:p-18'>
      <div className='flex w-full max-w-[1296px] flex-col items-center justify-center gap-x-18 gap-y-4 lg:flex-row'>
        <div className='flex max-w-[612px] flex-1 flex-col gap-10 lg:gap-8'>
          <h2 className='text-[32px] leading-[34px] font-[700] text-neutral-945 sm:text-[40px] sm:leading-[47px] lg:text-[44px]'>
            The world’s first app for{' '}
            <span className='text-azure-595'>listening to academic papers</span>
          </h2>
          <div className='text-[16px] leading-[24px] text-neutral-945 sm:text-[24px] sm:leading-[36px] lg:text-[20px] lg:leading-[30px]'>
            <p>
              Academic papers are{' '}
              <span className='font-bold'>very different</span> from other types
              of reading.
            </p>
          </div>
          <div className='flex flex-[0_auto] flex-col items-start justify-start gap-6 p-0'>
            <div className='flex items-start gap-4'>
              <img alt='Voiceprint' loading='lazy' src={voiceprintLineSvg} />
              <div className='text-[16px] leading-[21px] font-[400] text-neutral-700 sm:text-[18px] sm:leading-[24px]'>
                Skip directly to the section you care about (abstract, results,
                methods, etc)
              </div>
            </div>
            <div className='flex items-start gap-4'>
              <img alt='Speak' loading='lazy' src={speakLineSvg} />
              <div className='text-[16px] leading-[21px] font-[400] text-neutral-700 sm:text-[18px] sm:leading-[24px]'>
                Easily pronounces technical words in any field
              </div>
            </div>
            <div className='flex items-start gap-4'>
              <img alt='Format Clear    ' loading='lazy' src={formatClearSvg} />
              <div className='text-[16px] leading-[21px] font-[400] text-neutral-700 sm:text-[18px] sm:leading-[24px]'>
                Remove excess text, like references citations, and computer code
                from the audio
              </div>
            </div>
          </div>
        </div>
        <div className='relative flex-1 self-center lg:self-stretch'>
          <img alt='Ellipse' loading='eager' src={ellipse441Png} />
          <div className='absolute inset-x-0 bottom-[-85px] flex items-center justify-center lg:bottom-[-37px]'>
            <div className='max-w-[300px] text-center text-[14px] leading-[21px] font-[300] text-neutral-840 italic sm:text-[14px] sm:leading-[22px] lg:max-w-[auto]'>
              Not endorsed by or affiliated with these organizations
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
